// extracted by mini-css-extract-plugin
module.exports = {"imageFallbackDefault":"ImageWithFallback_imageFallbackDefault__Hgs_4","shimmer":"ImageWithFallback_shimmer__pA5PX"};